import { FC } from 'react';
import { Box, Center, Flex, Spinner, Text } from '@chakra-ui/react';

import { DITable } from 'plugins/DITable';
import TablePagination from 'plugins/DITable/Pagination';
import { useTranslation } from 'helpers/languages/translations';
import ClusterToolbar from './ClusterToolbar';
import useClusterContainer from './ClusterContainer';
import ClusterActionModal from './ClusterActionModal';

const ClusterViewer: FC<{ toolId: number }> = ({ toolId }) => {
    const props = useClusterContainer();
    const translate = useTranslation();
    const {
        isLoading,
        table,
        selectedRetailer,
        actionModalProps,
        actionModalType,
        setActionModalType,
        currentCluster,
    } = props;

    return (
        <>
            <Box mt="16px">
                {isLoading ? (
                    <Center w="100%" h="200px" bg="white" border="1px solid" borderColor="gray.100">
                        <Spinner />
                    </Center>
                ) : (
                    <>
                        <ClusterToolbar {...props} />
                        <DITable table={table} isPagination />
                        <TablePagination table={table} />
                    </>
                )}
            </Box>
            <ClusterActionModal
                {...actionModalProps}
                setActionModalType={setActionModalType}
                actionModalType={actionModalType}
                currentCluster={currentCluster}
            />
        </>
    );
};

export default ClusterViewer;
